import { useState } from "react";
import { ChevronDown, Download } from 'lucide-react';

export default function HistoryDropdown({
    history,
    currentArchiveUrl,
    onLoad,
    onDownload,
}: {
    history: Array<{ archive_url: string; label: string }>;
    currentArchiveUrl: string | null;
    onLoad: (url: string) => void;
    onDownload: (url: string) => void;
}) {
    const [open, setOpen] = useState(false);
    if (history.length <= 1) return null;

    return (
        <div className="relative inline-block ml-2">
            <button
                onClick={() => setOpen(o => !o)}
                className="px-3 py-1 text-sm bg-gray-100 text-gray-700 border border-gray-200 rounded hover:bg-gray-200 flex items-center gap-1"
            >
                Versions <ChevronDown className="w-4 h-4" />
            </button>
            {open && (
                <div className="absolute z-10 right-0 mt-2 w-48 bg-white border rounded shadow-lg max-h-60 overflow-y-auto">
                    {history.map((ver) => {
                        const isCurrent = ver.archive_url === currentArchiveUrl;
                        return (
                            <div key={ver.archive_url} className="flex justify-between group items-center">
                                <button
                                    className={
                                        "px-3 py-2 text-left text-sm w-full hover:bg-brixel/10 " +
                                        (isCurrent ? "font-bold text-brixel bg-brixel/10 cursor-default" : "")
                                    }
                                    onClick={() => { if (!isCurrent) { onLoad(ver.archive_url); setOpen(false); } }}
                                    disabled={isCurrent}
                                    title={isCurrent ? "Version courante" : "Charger cette version"}
                                >
                                    {ver.label}
                                </button>
                                <button
                                    className="px-2 py-1 text-gray-500 hover:text-brixel"
                                    onClick={() => onDownload(ver.archive_url)}
                                    title="Télécharger"
                                    tabIndex={-1}
                                >
                                    <Download className="w-4 h-4" />
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
